import { MButton, MModalBody, MModalFooter, MModalTitle, MTypography } from 'src/lib';
import { BaseStyle } from 'src/styles';

interface SecurityHoldingTradeMarketPriceStepProps {
  onBack: () => void;
}

export const SecurityHoldingTradeMarketPriceStep = ({ onBack }: SecurityHoldingTradeMarketPriceStepProps) => {
  return (
    <>
      <MModalTitle>Market Price</MModalTitle>
      <MModalBody>
        <MTypography variant='body1'>
          Market price fluctuates. The value displayed here may not reflect the most recent trade price for this
          security.
        </MTypography>
      </MModalBody>
      <MModalFooter className={BaseStyle.levelRight}>
        <MButton type='tertiary' onClick={onBack}>
          Back
        </MButton>
      </MModalFooter>
    </>
  );
};
